<template>
    <section class="user-banner">
        <div class="user-banner__bg -wrap">
            <span class="user-banner__headline" v-html="userFullName"></span>
        </div>
        <Tabs tabsMainClass="tabs-with-background" :userPage="true" :wrap="true" v-slot="tabsProps">
            <Tab
                v-for="(menuItem, index) in filteredUserMenu"
                :key="index"
                @tabMounted="tabsProps.onTabMounted"
                :activeTab="tabsProps.activeTab"
                :title="menuItem.title"
                :routerLink="menuItem.href"
            >
            </Tab>
        </Tabs>
    </section>
</template>

<script>
    import { mapGetters } from 'vuex'

    import Tab from 'components/layout/Tab'
    import Tabs from 'components/layout/Tabs'

    export default {
        components: {
            Tab,
            Tabs
        },
        data () {
            return {
                activeTab: this.$route.name
            }
        },
        computed: {
            ...mapGetters({
                userMenu: 'Menu/getUserMenu',
                user: 'User/getCurrentUser',
                getUserInfo: 'User/getUserInfo'
            }),
            isDesktopBannerTabs () {
                return this.$mq.includes('desktop_xxxl') || this.$mq.includes('desktop_xxl')
            },
            mobileUserMenu () {
                return this.userMenu
                    .filter(el => el.attributes.id !== 'knowledge-center' && el.attributes.id !== 'logout')
                    .map(el => ({
                        label: el.title,
                        value: el.href.name
                    }))
            },
            selectedUserPageOption () {
                return this.mobileUserMenu.find(el => el.value === this.$route.name)
            },
            filteredUserMenu () {
                return this.userMenu.filter((menuItem) => menuItem.attributes.id !== 'knowledge-center' && menuItem.attributes.id !== 'logout')
            },
            userFullName () {
                return this.getUserInfo?.firstName + ' ' + this.getUserInfo?.lastName
            }
        },
        methods: {
            goToUserPage (option) {
                this.$router.push({ name: option.value })
            },
            logout () {
                this.$store.dispatch('logout')
                this.$router.push({ name: 'home' })
            }
        }
    }
</script>

<style lang="scss">
    @include tabs_with_background;

    .user-banner {
        background-color: $light_blue;
        display: flex;
        flex-direction: column;
        padding: 0;

        &__select {
            [class*="mobile_sm"] & {
                margin: 0 0 20px 0;
            }
        }
        &__bg {
            background-color: $light_blue;
            height: 120px;
            display: flex;
            align-items: center;

            [class*="mobile"] & {
                height: 125px;
            }
        }
        &__headline {
            font-family: PPAgrandir-Medium, sans-serif;
            color: $lavender;
            font-size: 3.5rem;
            padding: 0;
            display: flex;
        }
    }
</style>
